import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RhNotification } from '../api/models/RhNotification';

type State = {
  /** Scheduled notifications */
  scheduledList: RhNotification[];
  /** Past notifications */
  pastList: RhNotification[];
};

export const communicationSlice = createSlice({
  name: 'communication',
  initialState: {
    scheduledList: [],
    pastList: [],
  } as State,
  reducers: {
    receivedScheduledList: (
      state,
      action: PayloadAction<{ scheduledNotifications: RhNotification[] }>
    ) => {
      state.scheduledList = action.payload.scheduledNotifications;
    },
    receivedPastList: (state, action: PayloadAction<{ pastNotifications: RhNotification[] }>) => {
      state.pastList = action.payload.pastNotifications;
    },
  },
});
